import {createI18n} from 'vue-i18n';
import en from './components/lang/en/ed.js';
import it from './components/lang/it/ed.js';

const searchParams = new URL(document.location.href).searchParams;
const lang = searchParams.get('lang') || 'en';

const i18n = createI18n({
  legacy: false,
  locale: lang,
  fallbackLocale: 'en',
  messages: {
    en,
    it
  }
});

export const translate = i18n.global.t;

export default i18n;
